import React, { useEffect, useState } from 'react';

import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import styled from 'styled-components';

import { SPREADSHEET_PREDEFINED_COLORS } from 'components/Settings/constants';

const ColorGrid = styled.div`
  background-color: white;
  display: grid;
  grid-template-columns: repeat(5, 16px);
  grid-gap: 10px;
  padding: 10px;
  border: 1px solid var(--line-gray);
`;

const ColorCircle = styled.div<{ color: string; selected?: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  border: ${({ selected }) => (selected ? 'solid 1px #275aff;' : undefined)};
  cursor: pointer;
`;

const ColorRectangle = styled.div<{ color: string }>`
  width: 28px;
  height: 28px;
  background-color: ${({ color }) => color};
  box-sizing: border-box;
`;

const StyledButton = styled(Button)`
  padding: 4px;
  border-radius: 0;
  border-color: var(--line-gray);
  box-sizing: border-box;
  height: 36px;
`;

type Props = {
  color: string;
  onSelectColor: (color: string) => void;
};

const PreferedColorPicker = ({ color, onSelectColor }: Props) => {
  const [selectedColor, setSelectedColor] = useState(Object.values(SPREADSHEET_PREDEFINED_COLORS)[0]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (color?.length && Object.values(SPREADSHEET_PREDEFINED_COLORS).includes(color)) {
      setSelectedColor(color);
    } else {
      setSelectedColor(Object.values(SPREADSHEET_PREDEFINED_COLORS)[0]);
    }
  }, [color]);

  const applySelection = (color: string) => {
    setSelectedColor(color);
    onSelectColor(color);
    setOpen(false);
  };

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomLeft"
      open={open}
      onOpenChange={(flag) => setOpen(flag)}
      dropdownRender={() => (
        <ColorGrid>
          {Object.values(SPREADSHEET_PREDEFINED_COLORS).map((color) => (
            <ColorCircle
              key={color}
              color={color}
              selected={color === selectedColor}
              onClick={() => applySelection(color)}
            />
          ))}
        </ColorGrid>
      )}
    >
      <StyledButton>
        <ColorRectangle color={selectedColor} />
        <DownOutlined />
      </StyledButton>
    </Dropdown>
  );
};

export default PreferedColorPicker;
